import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Steps,
  Button,
  Form,
  Input,
  Select,
  Row,
  Col,
  Checkbox,
  Upload,
  message,
  Card,
  Progress,
  Anchor,
} from "antd";
import { CloseOutlined, UploadOutlined } from "@ant-design/icons";
import FormItem from "antd/es/form/FormItem";
import MultiSelectCheckboxGroup from "./MultiSelectCheckboxGroup";
import { formatSizeBytes } from "../../common/helpers";
import { GetUserProfile } from "../../API/endpoints/User";
import { useNavigate, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import Navbar from "../components/header/NavBar";
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import AddNewMarketModal from "../components/modalForms/Partner/AddNewMarketModel";
import {
  addNewPartner,
  createNewPartner,
  deletePartnerFile,
  getPartnerByID,
  getPartnerFile,
  updatePartner,
  uploadPartnerFile,
  UploadPartnerMandatoryFile,
} from "../../API/endpoints/Partner";
import BusinessInfo from "./BusinessInfo";
import MarketSelection from "./MarketSelection";
import ServiceAndScope from "./ServiceAndScope";
import AdditionalOfferings from "./AdditionalOfferings";

const { Step } = Steps;
const { Option } = Select;

const AddNewPartner = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [businessInfoForm] = Form.useForm();
  const [marketSelectionForm] = Form.useForm();
  const [serviceScopeForm] = Form.useForm();

  const [current, setCurrent] = useState(0);
  const [userProfile, setUserProfile] = useState<any>({});
  const [userID, setUserID] = useState<string | undefined>("");
  const [partnerDetails, setPartnerDetails] = useState<any>({});

  const [otherValues, setOtherValues] = useState<{
    [marketName: string]: {
      [category: string]: string;
    };
  }>({});

  // const [openAddNewMarketModal, setOpenAddNewMarketModal] = useState(false);
  // const [selectedMarkets, setSelectedMarkets] = useState<string[]>([
  //   "Indonesia",
  // ]);

  // const [serviceScopeData, setServiceScopeData] = useState<any>({});

  const [selectedFiles, setSelectedFiles] = useState<any>([]);
  const [selectedCompanyOverview, setSelectedCompanyOverview] = useState<any>(
    []
  );
  const [selectedClientPortfolio, setSelectedClientPortfolio] = useState<any>(
    []
  );
  const [selectedDraftAgreement, setSelectedDraftAgreement] = useState<any>([]);

  // Focus Category state

  const [selectedHealthOptions, setSelectedHealthOptions] = useState<string[]>(
    []
  );
  const [selectedBeautyOptions, setSelectedBeautyOptions] = useState<string[]>(
    []
  );
  const [selectedChannelCoverage, setSelectedChannelCoverage] = useState<
    string[]
  >([]);

  // Add this to AddNewPartner.tsx
  const [selectedFoodBeverage, setSelectedFoodBeverage] = useState<string[]>(
    []
  );
  const [selectedPetNutrition, setSelectedPetNutrition] = useState<string[]>(
    []
  );
  const [selectedKeyCapabilities, setSelectedKeyCapabilities] = useState<
    string[]
  >([]);
  const [selectedWarehousing, setSelectedWarehousing] = useState<string[]>([]);
  const [selectedBusinessModels, setSelectedBusinessModels] = useState("");
  const [selectedTradingTerms, setSelectedTradingTerms] = useState("");
  const [selectedMarketingInvestment, setSelectedMarketingInvestment] =
    useState("");
  const [selectedPaymentTerms, setSelectedPaymentTerms] = useState("");

  // Additional Offerings - Value Added Services

  const [selectedValueServices, setSelectedValueServices] = useState<string[]>(
    []
  );
  const [selectedFinancial, setSelectedFinancial] = useState<string[]>([]);
  const [marketList, setMarketList] = useState([]);
  const [editPartnerData, setEditPartnerData] = useState<any>({});

  const [mandatoyFiles, setMandatoyFiles] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const containerRef = useRef(null);

  const serviceScopeData = {
    selectedHealthOptions,
    setSelectedHealthOptions,
    selectedBeautyOptions,
    setSelectedBeautyOptions,
    selectedChannelCoverage,
    setSelectedChannelCoverage,
    selectedFoodBeverage,
    setSelectedFoodBeverage,
    selectedPetNutrition,
    setSelectedPetNutrition,
    selectedKeyCapabilities,
    setSelectedKeyCapabilities,
    selectedWarehousing,
    setSelectedWarehousing,
    selectedBusinessModels,
    setSelectedBusinessModels,
    selectedTradingTerms,
    setSelectedTradingTerms,
    selectedMarketingInvestment,
    setSelectedMarketingInvestment,
    selectedPaymentTerms,
    setSelectedPaymentTerms,
    otherValues,
    setOtherValues,
  };

  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  useEffect(() => {
    if (!params?.partnerid) return;

    const fetchPartnerData = async () => {
      try {
        const [partnerRes, fileRes] = await Promise.all([
          getPartnerByID(params.partnerid),
          getPartnerFile(params.partnerid),
        ]);

        const partnerData = partnerRes?.data || {};
        const additionalDocs = Array.isArray(fileRes?.data)
          ? fileRes.data.map((doc: any) => doc.path)
          : [];

        setEditPartnerData((prev: any) => ({
          ...prev,
          ...partnerData,
          additionalDocDetails: fileRes?.data,
          additionalDocs,
        }));

        businessInfoForm.setFieldsValue({
          name: partnerData.name,
          country_of_origin: partnerData?.region?.id,
          poc_name: partnerData.poc_name,
          poc_designation: partnerData.poc_designation,
          poc_email: partnerData.poc_email,
          poc_countrycode: partnerData.poc_countrycode,
          poc_phone: partnerData.poc_phone,
          website: partnerData.website,
        });
      } catch (error) {
        console.error("Error fetching partner data:", error);
      }
    };

    fetchPartnerData();
  }, [params?.partnerid]);

  useEffect(() => {
    if (
      editPartnerData?.market?.length &&
      marketList?.length &&
      !partnerDetails?.marketSelection?.length
    ) {
      const matchedMarkets = marketList.filter((market: any) =>
        editPartnerData.market.some((m: any) => m.region === market.id)
      );

      setPartnerDetails((prev: any) => ({
        ...prev,
        marketSelection: matchedMarkets,
      }));
    }
  }, [editPartnerData, marketList]);

  useEffect(() => {
    if (partnerDetails?.marketSelection?.length) {
      marketSelectionForm.setFieldsValue({
        markets: partnerDetails.marketSelection.map((m: any) => m.id),
      });
    }
  }, [partnerDetails.marketSelection, current]);

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          // setRoleID(response.data?.user_roles[0]?.roles.id);
          // setPartnerID(response.data?.partnerv2_id);
          setUserProfile(response?.data);
          if (response?.data?.user_type === "consultant") {
            // setConsultantID(response?.data?.id);
          }
        }
      })();
    }
  }, [userID, navigate]);

  const next = () => {
    if (current === 0) {
      businessInfoForm
        .validateFields()
        .then((values) => {
          setPartnerDetails((prev: any) => ({
            ...prev,
            businessInfo: { ...values },
          }));
          setCurrent(current + 1);
        })
        .catch(() => {
          console.warn("Validation failed for Step 1");
        });
    } else if (current === 1) {
      marketSelectionForm
        .validateFields()
        .then((values) => {
          if (!values.markets?.length) {
            message.error("Please select at least one market.");
            return;
          }

          const selectedFromForm = marketList.filter((market: any) =>
            values.markets.includes(market.id)
          );

          const selectedIds = new Set(values.markets);

          // // Filter out old markets not in the newly selected ones
          // const newMarketSelection = (
          //   partnerDetails.marketSelection || []
          // ).filter((market: any) => selectedIds.has(market.id));

          const newMarkets: any = {};
          const newOtherValues: any = {};

          selectedFromForm.forEach((market: any) => {
            if (partnerDetails.markets?.[market.name]) {
              newMarkets[market.name] = partnerDetails.markets[market.name];
            }
            if (otherValues?.[market.name]) {
              newOtherValues[market.name] = otherValues[market.name];
            }
          });

          setPartnerDetails((prev: any) => ({
            ...prev,
            marketSelection: selectedFromForm,
            markets: newMarkets,
          }));
          setOtherValues(newOtherValues);
          setCurrent(current + 1);
        })
        .catch(() => {
          console.warn("Step 2 validation failed");
        });
    } else if (current === 2) {
      const serviceScopeComponent: any = document.querySelector(
        '[data-component="ServiceAndScope"]'
      );
      if (serviceScopeComponent?.saveCurrentMarketData) {
        serviceScopeComponent.saveCurrentMarketData();
      }

      const allMarkets = partnerDetails.marketSelection || [];
      const allMarketsData = partnerDetails.markets || {};

      for (const market of allMarkets) {
        const data = allMarketsData[market.name];
        console.log(allMarketsData, "allMarketsData", market.name);

        if (!data) {
          message.error(
            `Please complete all fields for market: ${market.name}`
          );
          return;
        }

        const {
          focus_categories,
          channel_coverage,
          service_capabilities,
          warehousing,
          engagement_model,
          trading_terms,
          minimum_tenure,
          trade_marketing_investments,
          payment_terms,
        } = data;

        // const hasAnyFocusCategory =
        //   focus_categories?.["Health Supplements"]?.value?.length ||
        //   focus_categories?.["Beauty & Skin"]?.value?.length ||
        //   focus_categories?.["Functional Food & Beverages"]?.value?.length ||
        //   focus_categories?.["Pet Nutrition"]?.value?.length;
        const getLength = (val: any) => {
          if (Array.isArray(val)) return val.length;
          if (val?.value && Array.isArray(val.value)) return val.value.length;
          return 0;
        };

        const hasAnyFocusCategory =
          getLength(focus_categories?.["Health Supplements"]) ||
          getLength(focus_categories?.["Beauty & Skin"]) ||
          getLength(focus_categories?.["Functional Food & Beverages"]) ||
          getLength(focus_categories?.["Pet Nutrition"]);

        if (!hasAnyFocusCategory) {
          message.error(
            `Please select at least one focus category for ${market.name}`
          );
          return;
        }

        const checkSub = (cat: string, label: string) => {
          const items = focus_categories?.[cat] || [];
          if (
            items.length &&
            items.filter((opt: any) => opt !== "Other").length === 0
          ) {
            message.error(
              `Please select at least one ${label} sub-category for ${market.name}`
            );
            return false;
          }
          return true;
        };

        if (
          !checkSub("Health Supplements", "Health Supplements") ||
          !checkSub("Beauty & Skin", "Beauty & Skin") ||
          !checkSub(
            "Functional Food & Beverages",
            "Functional Food & Beverages"
          ) ||
          !checkSub("Pet Nutrition", "Pet Nutrition")
        ) {
          return;
        }

        if (!channel_coverage?.length) {
          message.error(
            `Please select at least one Key Channel Coverage for ${market.name}`
          );
          return;
        }

        if (!service_capabilities?.length) {
          message.error(
            `Please select at least one Key Capability for ${market.name}`
          );
          return;
        }

        if (
          service_capabilities.includes("Warehousing") &&
          (!warehousing || warehousing.length === 0)
        ) {
          message.error(
            `Please select at least one Warehousing capability for ${market.name}`
          );
          return;
        }

        if (!engagement_model?.[0]) {
          message.error(`Please select one Business Model for ${market.name}`);
          return;
        }

        if (!trading_terms) {
          message.error(`Please select one Trading Term for ${market.name}`);
          return;
        }

        if (!minimum_tenure) {
          message.error(`Please select one Minimum tenure for ${market.name}`);
          return;
        }

        if (!trade_marketing_investments) {
          message.error(
            `Please select one Marketing Investment for ${market.name}`
          );
          return;
        }

        if (!payment_terms?.[0]) {
          message.error(`Please select one Payment Term for ${market.name}`);
          return;
        }
      }

      setCurrent(current + 1);
    } else if (current === 3) {
      if (!selectedValueServices.length) {
        message.error("Please select at least one Value Added Service");
        return;
      }

      if (
        selectedValueServices.includes("Other") &&
        (!partnerDetails?.otherValueService ||
          partnerDetails.otherValueService.trim().length === 0)
      ) {
        message.error(
          "Please enter a valid value for 'Other' in Value Added Services"
        );
        return;
      }

      if (!selectedFinancial.length) {
        message.error("Please select at least one Financial Assistance option");
        return;
      }

      if (
        selectedFinancial.includes("Other") &&
        (!partnerDetails?.otherFinancial ||
          partnerDetails.otherFinancial.trim().length === 0)
      ) {
        message.error(
          "Please enter a valid value for 'Other' in Financial Assistance"
        );
        return;
      }

      onSubmit();
    }
  };

  const prev = () => setCurrent(current - 1);

  const onSubmit = () => {
    setLoading(true);
    const req = {
      ...partnerDetails.businessInfo,
      markets: partnerDetails.markets,
      value_added_services: partnerDetails.value_added_services,
      financial_assistance: partnerDetails.financial_assistance,
      country_of_origin: Number(partnerDetails.businessInfo.country_of_origin),
    };
    if (editPartnerData && Object.keys(editPartnerData).length) {
      const formattedMarkets = Object.entries(
        partnerDetails?.markets || {}
      ).map(([marketName, marketData]: any) => {
        const originalMarket = editPartnerData.market.find(
          (m: any) => m.region === marketData.region
        );

        return {
          region: marketData.region,
          marketId: originalMarket?.id,
          categories: Object.entries(marketData.focus_categories || {}).map(
            ([category, data]: any) => {
              const originalCategory = originalMarket?.categories?.find(
                (c: any) => c.focus_category === category
              );
              const subCategories = Array.isArray(data)
                ? data
                : data?.value || [];

              return {
                focus_category: category,
                id: originalCategory?.id || "",
                value: subCategories,
              };
            }
          ),
          channel_coverage: marketData.channel_coverage,
          service_capabilities: marketData.service_capabilities,
          warehousing: marketData.warehousing,
          engagement_model: marketData.engagement_model,
          trading_terms: marketData.trading_terms,
          minimum_tenure: marketData.minimum_tenure,
          trade_marketing_investments: marketData.trade_marketing_investments,
          payment_terms: marketData.payment_terms,
        };
      });

      const updateReq = {
        ...partnerDetails.businessInfo,
        name: partnerDetails.businessInfo.name,
        markets: formattedMarkets,
        value_added_services: partnerDetails.value_added_services,
        financial_assistance: partnerDetails.financial_assistance,
        country_of_origin: Number(
          partnerDetails.businessInfo.country_of_origin
        ),
      };

      updatePartner(updateReq, params?.partnerid)
        .then(async (res: any) => {
          //  Upload only newly updated documents
          const uploadTasks = [];

          if (mandatoyFiles.company_overview) {
            mandatoyFiles.company_overview.set("partner_id", params?.partnerid);
            uploadTasks.push(
              UploadPartnerMandatoryFile(mandatoyFiles.company_overview)
            );
          }

          if (mandatoyFiles.client_portfolio) {
            mandatoyFiles.client_portfolio.set("partner_id", params?.partnerid);
            uploadTasks.push(
              UploadPartnerMandatoryFile(mandatoyFiles.client_portfolio)
            );
          }

          if (mandatoyFiles.draft_agreements) {
            mandatoyFiles.draft_agreements.set("partner_id", params?.partnerid);
            uploadTasks.push(
              UploadPartnerMandatoryFile(mandatoyFiles.draft_agreement)
            );
          }

          if (mandatoyFiles.additionalUploads) {
            // Delete old additional document (if any)
            if (editPartnerData?.additionalDocDetails?.[0]?.id) {
              await deletePartnerFile(
                editPartnerData.additionalDocDetails[0].id
              );
            }

            // Set partner ID and upload new doc
            mandatoyFiles.additionalUploads.set(
              "partner_id",
              params?.partnerid
            );
            uploadTasks.push(
              uploadPartnerFile(mandatoyFiles.additionalUploads)
            );
          }

          if (uploadTasks.length) {
            await Promise.all(uploadTasks);
            message.success("Partner updated with new files!");
          } else {
            message.success("Partner updated successfully!");
          }

          setLoading(false);
          navigate("/PartnerManagement");
        })
        .catch((err: any) => {
          setLoading(false);
          console.error("Error updating partner:", err);
          message.error("Update failed. Please try again.");
        });

      return;
    } else
      createNewPartner(req)
        .then(async (res: any) => {
          const partnerID = res?.data?.id;

          if (!partnerID) {
            message.error("Failed to get partner ID.");
            setLoading(false);
            return;
          }

          // 1. Add partner_id to all files
          Object.keys(mandatoyFiles).forEach((key) => {
            mandatoyFiles[key].set("partner_id", partnerID);
          });

          let fileUploadError = false;

          // 2. Upload all files
          try {
            await Promise.all([
              mandatoyFiles.company_overview &&
                UploadPartnerMandatoryFile(mandatoyFiles.company_overview),
              mandatoyFiles.client_portfolio &&
                UploadPartnerMandatoryFile(mandatoyFiles.client_portfolio),
              mandatoyFiles.draft_agreements &&
                UploadPartnerMandatoryFile(mandatoyFiles.draft_agreements),
              mandatoyFiles.additionalUploads &&
                uploadPartnerFile(mandatoyFiles.additionalUploads),
            ]);
          } catch (err) {
            fileUploadError = true;
            console.error("File upload error:", err);
            message.error("Some files failed to upload.");
          }

          // 3. Update Partner Status to APPROVED (runs regardless of file upload result)
          try {
            const approveDataPayload = { status: "APPROVED" };
            await updatePartner(approveDataPayload, partnerID);
          } catch (err) {
            console.error("Failed to approve partner:", err);
            message.error("Files processed, but approval failed.");
            setLoading(false);
            navigate("/PartnerManagement");
            return;
          }

          // 4. Final message based on upload result
          if (fileUploadError) {
            message.warning(
              "Partner approved, but some files failed to upload."
            );
          } else {
            message.success("Partner created and approved successfully!");
          }

          setLoading(false);
          navigate("/PartnerManagement");
        })
        .catch((err: any) => {
          console.error("Something went wrong:", err);
          message.error("Failed to create partner");
          setLoading(false);
          navigate("/PartnerManagement");
        });
  };

  const steps = [
    {
      title: "Business Info",
      content: (
        <BusinessInfo
          businessInfoForm={businessInfoForm}
          selectedCompanyOverview={selectedCompanyOverview}
          setSelectedCompanyOverview={setSelectedCompanyOverview}
          selectedClientPortfolio={selectedClientPortfolio}
          setSelectedClientPortfolio={setSelectedClientPortfolio}
          selectedDraftAgreement={selectedDraftAgreement}
          setSelectedDraftAgreement={setSelectedDraftAgreement}
          selectedFiles={selectedFiles}
          setSelectedFiles={setSelectedFiles}
          setMandatoyFiles={setMandatoyFiles}
          mandatoyFiles={mandatoyFiles}
          editPartnerData={editPartnerData}
        />
      ),
    },
    {
      title: "Market Selection",
      content: (
        <MarketSelection
          marketSelectionForm={marketSelectionForm}
          marketList={marketList}
          setMarketList={setMarketList}
        />
      ),
    },
    {
      title: "Service & Scope",
      content: (
        <ServiceAndScope
          containerRef={containerRef}
          serviceScopeForm={serviceScopeForm}
          setPartnerDetails={setPartnerDetails}
          editPartnerData={editPartnerData}
          partnerDetails={partnerDetails}
          serviceScopeData={serviceScopeData}
        />
      ),
    },
    {
      title: "Additional Offerings",
      content: (
        <AdditionalOfferings
          setPartnerDetails={setPartnerDetails}
          selectedValueServices={selectedValueServices}
          setSelectedValueServices={setSelectedValueServices}
          selectedFinancial={selectedFinancial}
          setSelectedFinancial={setSelectedFinancial}
          editPartnerData={editPartnerData}
          setEditPartnerData={setEditPartnerData}
        />
      ),
    },
  ];

  return (
    <section>
      <Navbar userProfile={userProfile} />
      <Breadcrumb className="font12-medium breadcrumb-nav bg-[#f0f2f5]">
        <Breadcrumb.Item active>
          <Link to="/PartnerManagement">PARTNER MANAGEMENT</Link>{" "}
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span className="!text-[#1D2939] text-[12px] font-[500] ">
            ADD NEW PARTNER
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <div className="p-[40px] min-h-[100vh] bg-[#f0f2f5] ">
        <div className="bg-[#fff] max-w-[1100px] m-[0_auto] ">
          <div className="p-[12px_16px] flex items-center justify-between  border-b-[1px] border-[#E4E7EC] ">
            <p className="m-[0] ">Add New Partner</p>
            {/* Navigation Buttons */}
            <div className="flex gap-[8px] items-center ">
              {current > 0 ? (
                <Button type="default" onClick={prev}>
                  Previous
                </Button>
              ) : (
                <div />
              )}
              <Button
                loading={loading}
                className="!bg-[#0152FB]"
                type="primary"
                onClick={next}
              >
                {current < steps.length - 1 ? "Next" : "Submit"}
              </Button>
            </div>
          </div>
          <div className="flex p-[0_24px_24px] ">
            {/* Stepper */}
            <div className="w-[250px] pt-[24px] pg-[32px] mr-[24px] border-r-[1px] border-[#E4E7EC] ">
              <Steps
                className="custom-vertical-steps"
                direction="vertical"
                current={current}
              >
                {steps.map((item) => (
                  <Step
                    className="!h-[80px]"
                    key={item.title}
                    title={item.title}
                  />
                ))}
              </Steps>
            </div>

            {/* Form Content */}
            <div className="pt-[24px]" style={{ flex: 1 }}>
              {steps[current].title !== "Service & Scope" && (
                <h2 className="mb-[24px] font-[600] ">
                  {steps[current].title}
                </h2>
              )}
              <div>{steps[current].content}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddNewPartner;
